// view
export const FETCH_RESULTS = 'FETCH_RESULTS';
export const LIST_RESULTS = 'LIST_RESULTS';


// set
export const PUBLISH_RESULT = 'PUBLISH_RESULT';
export const FETCH_RESULT = 'FETCH_RESULT';
export const LIST_RESULT = 'LIST_RESULT';
export const MODIFIED_RESULT = 'MODIFIED_RESULT';
export const CLEAR_RESULT = 'CLEAR_RESULT';
export const UPDATE_RESULT = 'UPDATE_RESULT';
export const PUBLISHED_RESULT = 'PUBLISHED_RESULT';

export const FETCH_RESULT_V1 = 'FETCH_RESULT_V1';
export const LIST_RESULT_V1 = 'LIST_RESULT_V1';
